import React, { useState } from "react";
import toast from "react-hot-toast";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import { gbState } from "../../../components/shared/GlobalState";
import NoticeUserListChild from "./NoticeUserList";
import { FaPaperPlane, FaHeading, FaUsers, FaFileAlt } from "react-icons/fa";

const NoticeAdd = ({ currentRecord, setModel }) => {
  let navigate = useNavigate();
  //Error Logging Service & Santize Input
  const [{ errorLogApi, placeHolderText, user }] = useAtom(gbState);

  const [formData, setFormData] = useState({
    _id: currentRecord?._id ?? null,
    title: currentRecord?.title ?? null,
    description: currentRecord?.description ?? null,
    send_to: currentRecord?.sent_for ?? null,
    users: currentRecord?.mail_sent_to ?? [],
    church_id: user?.church_id,
    createdBy: user?._id,
  });
  const [sendData, setSendData] = useState();

  const handleChange = ({ currentTarget: input }) => {
    setFormData({
      ...formData,
      [input.name]: input.value,
    });
  };
  const handleSelected = ({ currentTarget: input }) => {
    setSendData(input.value);
  };
  const dropDownChange = (selected, dropdown) => {
    //console.log("this is selected", JSON.stringify(dropdown.name));
    setFormData({
      ...formData,
      [dropdown.name]: selected.value,
    });
  };

  const handleNotice = (e) => {
    e.preventDefault();
    let userToken = localStorage.getItem("token");
    let config = {};
    if (formData._id) {
      config = {
        method: "patch",
        url: `${process.env.REACT_APP_API_URL}/notice/update/${formData._id}`,
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
        data: { ...formData },
      };
    } else {
      config = {
        method: "post",
        url: `${process.env.REACT_APP_API_URL}/notice/add`,
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
        data: { ...formData },
      };
    }
    axios(config)
      .then(function (response) {
        //console.log(JSON.stringify(response.data));
        toast.success("Notice Send Successfully.");
        // Close the modal after saving
        navigate("/notices");
        setModel(false);
      })
      .catch(function (error) {
        //  toast.error(JSON.stringify(error.response.data.message));
        toast.error(JSON.stringify(error.response.data));
        errorLogApi(error, "CreateNoticeChild", "/notice/add");
        // console.log(error);
      });
  };
  return (
    <div className="flex justify-center w-full">
      <div className="w-full max-w-3xl p-6 bg-white rounded-lg shadow-md">
        <form
          onSubmit={(e) => handleNotice(e)}
          autoComplete="off"
          className="space-y-6"
        >
          <div className="flex items-center justify-between">
            <h2 className="text-2xl font-bold text-gray-800">Create Notice</h2>
            <button
              className="flex items-center px-4 py-2 space-x-2 text-white transition duration-300 bg-blue-600 rounded-md hover:bg-blue-700"
              type="submit"
            >
              <FaPaperPlane />
              <span>Send</span>
            </button>
          </div>

          <div className="space-y-2">
            <label
              htmlFor="title"
              className="block text-sm font-medium text-gray-700"
            >
              <FaHeading className="inline mr-2" />
              Title
            </label>
            <input
              className="w-full p-3 text-sm transition duration-300 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              name="title"
              type="text"
              required
              placeholder="Enter Title"
              onChange={handleChange}
              value={formData.title}
            />
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">
              <FaUsers className="inline mr-2" />
              Send To
            </label>
            <div className="flex flex-wrap gap-4">
              {["all", "members", "families", "employees"].map((option) => (
                <label key={option} className="inline-flex items-center">
                  <input
                    type="radio"
                    name="send_to"
                    value={option}
                    checked={formData.send_to === option}
                    onChange={handleSelected}
                    onClick={handleChange}
                    className="w-5 h-5 text-blue-600 form-radio"
                  />
                  <span className="ml-2 text-sm text-gray-700 capitalize">
                    {option}
                  </span>
                </label>
              ))}
            </div>
          </div>

          <div className="w-full">
            <NoticeUserListChild
              sendData={currentRecord ? formData.send_to : sendData}
              formData={formData}
              setFormData={setFormData}
            />
          </div>

          <div className="space-y-2">
            <label
              htmlFor="description"
              className="block text-sm font-medium text-gray-700"
            >
              <FaFileAlt className="inline mr-2" />
              Description
            </label>
            <textarea
              className="w-full p-3 text-sm transition duration-300 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              name="description"
              rows={4}
              required
              placeholder="Enter Notice Description"
              onChange={handleChange}
              value={formData.description}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default NoticeAdd;
